import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom'
import { Drawer, Theme } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import Settings from './settings/Settings';
import { anime } from 'react-anime';

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    overflow: 'visible',
  },
  drawerPaper: {
    width: 560,
    maxWidth: '100vw',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  toolbar: {
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      minHeight: 56,
      paddingLeft: 24,
      paddingRight: 8,
    },
  },
  logoWrap: {
    position: 'relative',
    width: 58,
    height: 45,
    margin: 16,
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      margin: '8px 8px 8px 16px',
      width: 58,
    },
  },
  brand: {
    marginTop: 16,
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Helvetica',
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
      fontSize: 12,
    },
  },
  menuButton: {
    margin: 16,
    [theme.breakpoints.down('sm')]: {
      margin: 4,
    },
  },
}));

export default function Header() {
  const theme = useTheme<Theme>()
  const classes = useStyles();
  const [settingsOpen, setSettingsOpen] = React.useState(false);

  function handleSettingsClicked() {
    setSettingsOpen(true)
  }

  function handleCloseSettings() {
    setSettingsOpen(false)
  }

  function animateCardHover() {
    let timeline = anime.timeline({
      targets: ".animCardLogoFront",
      easing: 'easeOutElastic'
    })
    timeline.add({
      targets: ".animHeaderCardLogoFront, .animHeaderCardLogoBack",
      duration: 800,
      rotate: 0,
      translateX: 0,
    })
    timeline.add({
      targets: ".animHeaderCardLogoFront",
      duration: 800,
      rotate: 25,
      translateX: 15,
    }, "-=500")
    timeline.add({
      targets: ".animHeaderCardLogoBack",
      duration: 800,
      rotate: -25,
      translateX: -15,
    }, "-=750")
  }

  return (
    <AppBar position="static" color="transparent" elevation={0} className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Link to={"/"} onMouseEnter={animateCardHover}>
          <div className={classes.logoWrap}>
            <div className="animHeaderCardLogoFront logoCardMini" style={{ backgroundColor: theme.palette.primary.main, zIndex: 3, transform: "rotate(25deg) translateX(15px)" }} />
            <div className="animHeaderCardLogoMiddle logoCardMini" style={{ backgroundColor: theme.palette.primary.main, filter: "brightness(70%)", zIndex: 2 }} />
            <div className="animHeaderCardLogoBack logoCardMini" style={{ backgroundColor: theme.palette.primary.main, filter: "brightness(50%)", zIndex: 1, transform: "rotate(-25deg) translateX(-15px)" }} />
          </div>
        </Link>

        <div className={classes.brand}>
          <div>EFFORT</div>
          <div>ESTIMATION</div>
        </div>

        <div style={{ flex: 1 }} />
        <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleSettingsClicked} className={classes.menuButton}>
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer
        anchor="right"
        open={settingsOpen}
        onClose={handleCloseSettings}
        classes={{ paper: classes.drawerPaper }}
        ModalProps={{
          BackdropProps: {
            invisible: true,
          },
        }}
      >
        <Settings handleCloseSettings={handleCloseSettings} />
      </Drawer>
    </AppBar>
  )
}
